import React from "react";

import { Container, Breadcrumb, Row, Col, Card } from "react-bootstrap";

const CommonBreadcrumb = (props) => {
  return (
    <Card
      className="breadcrumb__card"
      style={{ backgroundColor: "rgba(255, 255, 255, 0.3)" }}
    >
      <Container className="container-fluid crumb__width">
        <Row>
          <Col className="breadcrumb-margin">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href={props.href1}>
                {props.path1}
              </Breadcrumb.Item>
              {props.path2 && (
                <Breadcrumb.Item href={props.href2}>
                  {props.path2}
                </Breadcrumb.Item>
              )}
              {props.path3 && (
                <Breadcrumb.Item href={props.href3}>
                  {props.path3}
                </Breadcrumb.Item>
              )}
            </Breadcrumb>
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

export default CommonBreadcrumb;
